import { Mapper } from "../../../../base/utils/mapper";
import { TypeResidentialAreaModel } from "../../../../domain/models/consult/type-residential-area.model";
import { TypeResidentialAreaEntity } from "../entities/type-residential-area.entity";


export class TypeResidentialAreaImplementationRepositoryMapper extends Mapper<TypeResidentialAreaEntity, TypeResidentialAreaModel> {
    mapFrom(param: TypeResidentialAreaEntity): TypeResidentialAreaModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: TypeResidentialAreaModel): TypeResidentialAreaEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}